import { OrderStatus } from "@sso/constant";

import { Currency } from "./currency";
import { PaymentType } from "./softwareLicence";

export enum OrderSummaryRowKeys {
  ID = "id",
  CREATED_DATE = "createdDate",
  USER = "user",
  ORGANISATION = "organisation",
  DATE_RANGE = "dateRange",
  STATUS = "status",
  PAID = "paid",
  VALUE = "value",
  SOFTWARE_NAME = "softwareName",
  PAYMENT_MODE = "paymentMode",
  STATUS_LABEL = "statusLabel",
}

export interface OrderSummary {
  id: string;
  status: OrderStatus;
  softwareId: string;
  softwareName: string;
  currencyCode: string;
  transactionCurrency: Currency;
  paymentMode: PaymentType;
  fullName: string;
  total: number;
  totalTax: number;
  expiration: Date;
  createdDate: Date;
  invoiceUrl?: string;
  organisationName?: string;
}
